import React from 'react';
import { CURRENT_VERSION, CURRENT_LOG } from 'src/data/content';
import { COMMON_IMAGES, SOCIAL_LINKS } from 'src/data/constants';
import './Footer.css';

export const Footer = () => {
  return (
    <footer className='lnl-footer row'>
      <div className='footer-left'>
        <div className='brand-name'>Lights &amp; Lenses</div>
        <div className='footer-text'>
          <span className='version-number'>v{CURRENT_VERSION}</span>
          {CURRENT_LOG}
        </div>
      </div>
      <div className='footer-right'>
        <a href={SOCIAL_LINKS.instagram} target='_blank' rel='noreferrer'>
          <img src={COMMON_IMAGES.instagramLogo} className='social-link' alt='Instagram' />
        </a>
        <a href={SOCIAL_LINKS.facebook} target='_blank' rel='noreferrer'>
          <img src={COMMON_IMAGES.facebookLogo} className='social-link' alt='Facebook' />
        </a>
      </div>
    </footer>
  );
};
